import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-header-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "desease-select" }
const _hoisted_6 = { class: "desease-select-title" }
const _hoisted_7 = { class: "desease-select-text" }
const _hoisted_8 = {
  class: "desease-select-japaneseoder",
  id: "disease_initial"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "japaneseoder-item-other" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id", "value"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "japaneseoder" }
const _hoisted_15 = { class: "desease-select-other-text" }
const _hoisted_16 = {
  class: "desease-select-item other",
  id: "disease_name"
}
const _hoisted_17 = { for: "disease_other" }
const _hoisted_18 = { class: "disease-wrap" }
const _hoisted_19 = { class: "japaneseoder" }
const _hoisted_20 = { class: "desease-select-other-text" }
const _hoisted_21 = { class: "desease-select-item stakeholder" }
const _hoisted_22 = { for: "disease_stakeholder" }
const _hoisted_23 = { class: "disease-wrap" }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = { class: "modal-footer-buttons" }

import { ref, onMounted, computed } from "vue";
import { _$t } from "@/utils/i18n";
import { Profile } from "@/models/profile/profile";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose04-02-a-modal01";
const otherNameCode = "0000";
interface Disease {
  code: string;
  name: string;
  kana: string;
  status: number;
}

// ---- Variable ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'DiseaseModal',
  props: {
    selectedDiseaseCodes: {},
    otherdiseasename: {},
    isStakeholder: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const profile = new Profile();
const kanaList = ["あ", "か", "さ", "た", "な", "は", "ま", "や", "ら", "わ"];
const props = __props;
const emits = __emit;
const selectedKana = ref("");
const showInitialStatus = ref(true);
const allDiseases = ref<Disease[]>([]);
const selectedCodes = ref<string[]>([...props.selectedDiseaseCodes]); // 親からもらったオプション
// その他病名変数
const isOtherDiseaseVisable = ref(false);
const otherName = ref<string>(props.otherdiseasename || "");
// 病名なし変数
const isStakeholderChecked = ref<boolean>(props.isStakeholder || false);

// エラー
const hasError = ref(false);
let errorMessage: string;

// ----- Function -----------------------------------------------
//カナ選択
const selectKana = (kana: string) => {
  selectedKana.value = kana;
  showInitialStatus.value = false;
  isOtherDiseaseVisable.value = false;
};

//トグルその他
const toggleOtherDisease = () => {
  isOtherDiseaseVisable.value = true;
  selectedKana.value = "";
};

// 病名なしがチェックされた時の処理
const handleStakeholderChange = () => {
  if (isStakeholderChecked.value) {
    // 病名なしがチェックされたら、他のすべての選択を解除
    selectedCodes.value = [];
    otherName.value = "";
  }
};

// 病名選択時に病名なしのチェックを解除
const handleDiseaseChange = () => {
  if (selectedCodes.value.length > 0 && isStakeholderChecked.value) {
    isStakeholderChecked.value = false;
  }
};

// 病名情報取得
const fetchDiseases = async () => {
  await profile.getAllDiseases().then(([model, _response, err]) => {
    if (err) {
      errorMessage = decodeURIComponent(err.error?.response?.data?.message);
      hasError.value = true;
      return;
    } else {
      allDiseases.value = model.attributes?.result || null;
    }
  });
};

// 条件により、病名を表示する
const filteredDiseases = computed(() => {
  // 初期化表示、注力疾患を表示する
  if (showInitialStatus.value) {
    return allDiseases.value.filter((d) => d.status === 1);
  }
  // 上記以外、選択された仮名により病名を表示する
  return allDiseases.value.filter((d) => d.kana === selectedKana.value);
});

// OKボタン押下
const saveSelection = () => {
  // エラーメッセージリセット
  errorMessage = "";

  // 病名ラベルをカンマ区切りで結合する
  let selectedDiseaseNames = allDiseases.value
    .filter((disease) => selectedCodes.value.includes(disease.code))
    .filter((disease) => disease.code !== otherNameCode)
    .map((disease) => disease.name)
    .filter((name) => name?.trim())
    .join(", ");

  let isOtherChecked = (
    document.getElementById("disease_other") as HTMLInputElement
  ).checked;

  let isOtherText = document.getElementById(
    "disease_other_text"
  ) as HTMLInputElement;

  // 病名必須チェック（病名なしがチェックされている場合は除外）
  if (selectedCodes.value.length === 0 && !isStakeholderChecked.value) {
    hasError.value = true;
    errorMessage = _$t("msg_error_select_disease_required");
    return;

    // 「その他」にチェック、病名未記入の場合、
  } else if (isOtherChecked && isOtherText.value.trim() === "") {
    hasError.value = true;
    errorMessage = _$t("msg_error_other_disease_text_required");
    return;

    // 「その他」にチェックなし、病名記入済の場合、
  } else if (!isOtherChecked && isOtherText.value.trim() !== "") {
    hasError.value = true;
    errorMessage = _$t("msg_error_other_disease_checked_required");
    return;
  }

  hasError.value = false;
  errorMessage = "";
  emits(
    "save",
    selectedCodes.value,
    selectedDiseaseNames,
    otherName.value?.trim(),
    isStakeholderChecked.value
  );
};

onMounted(fetchDiseases);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("body", null, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("profile_edit_disease_modal_header")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/server/necs/images/expand_circle_down_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png" }, null, -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("profile_edit_kanafilter_select_text")), 1)
            ]),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(kanaList, (kana) => {
                return _createElementVNode("li", {
                  key: kana,
                  class: _normalizeClass(["japaneseoder-item", { selected: kana === selectedKana.value }]),
                  onClick: ($event: any) => (selectKana(kana))
                }, _toDisplayString(kana), 11, _hoisted_9)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "japaneseoder-item-other-button",
                onClick: toggleOtherDisease
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  class: "japaneseoder-item-other-button-icon",
                  src: "/server/necs/images/arrow-right_icon.png"
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile_edit_other_disease")), 1)
              ])
            ])
          ]),
          (showInitialStatus.value === false)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["japaneseoder", { unselected: isOtherDiseaseVisable.value }])
              }, _toDisplayString(selectedKana.value) + _toDisplayString(_ctx.$t("profile_edit_row")), 3))
            : _createCommentVNode("", true),
          _createElementVNode("ul", {
            class: _normalizeClass(["desease-select-wrap", { other: isOtherDiseaseVisable.value }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDiseases.value, (disease) => {
              return (_openBlock(), _createElementBlock("li", {
                key: disease.code,
                class: "desease-select-item",
                id: `disease_${disease.code}`
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "desease-select-name",
                  id: `disease_name_${disease.code}`,
                  value: disease.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCodes).value = $event)),
                  onChange: handleDiseaseChange
                }, null, 40, _hoisted_12), [
                  [_vModelCheckbox, selectedCodes.value]
                ]),
                _createElementVNode("label", {
                  for: `disease_name_${disease.code}`
                }, [
                  _createElementVNode("span", null, _toDisplayString(disease.name), 1)
                ], 8, _hoisted_13)
              ], 8, _hoisted_11))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["desease-select-other", { unselected: !isOtherDiseaseVisable.value }])
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("profile_edit_select_other_title")), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("profile_edit_select_other_text")), 1),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "desease-select-name",
                id: "disease_other",
                value: otherNameCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCodes).value = $event)),
                onChange: handleDiseaseChange
              }, null, 544), [
                [_vModelCheckbox, selectedCodes.value]
              ]),
              _createElementVNode("label", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile_edit_disease_other_label")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "desease-select-other-input",
                    id: "disease_other_text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((otherName).value = $event))
                  }, null, 512), [
                    [_vModelText, otherName.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("profile_edit_stakeholder_title")), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("profile_edit_stakeholder_text")), 1),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "stakeholder-checkbox",
                id: "disease_stakeholder",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isStakeholderChecked).value = $event)),
                onChange: handleStakeholderChange
              }, null, 544), [
                [_vModelCheckbox, isStakeholderChecked.value]
              ]),
              _createElementVNode("label", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile_edit_disease_select_stakeholder")), 1)
                ])
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-footer-error", hasError.value ? 'active' : ''])
          }, _toDisplayString(_unref(errorMessage)), 3),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              class: "modal-cansel",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
            }, _toDisplayString(_ctx.$t("button_cancel_label")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "modal-ok",
              onClick: saveSelection
            }, _toDisplayString(_ctx.$t("button_ok_label")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})